import each from 'lodash/each'
import escape from 'lodash/escape'
import keys from 'lodash/keys'
import pickBy from 'lodash/pickBy'
import $ from 'jquery'
import Vue from 'vue'
import '../component/DataTable'

import '../../../scss/app/unclaimed_capital_credits.scss'

const UnclaimedCapitalCredits = Vue.extend({
  // language=HTML (for PhpStorm)
  template: `
    <div class="ucc">
      <div class="row">
        <div class="small-12 columns">
          <template v-if="step === 1">
            <form method="post" @submit.prevent="submit">
              <div class="d-lg-flex">
                <div class="form-group me-3">
                  <label for="name">Name or Company Name</label>
                  <input type="text" id="name" v-model="filter.name" autocomplete="off">
                  <span v-if="error.name" class="form-error" aria-hidden="false">
                    <ul>
                      <li>{{ error.name }}</li>
                    </ul>
                  </span>
                </div>
                <div class="form-group me-3">
                  <label for="zip">Zip</label>
                  <input type="text" id="zip" v-model="filter.zip" autocomplete="off">
                  <span v-if="error.zip" class="form-error" aria-hidden="false">
                    <ul>
                      <li>{{ error.zip }}</li>
                    </ul>
                  </span>
                </div>
                <div class="form-group align-self-end">
                  <button type="submit" class="button" style="margin: 0">Search</button>
                </div>
              </div>
            </form>

            <div class="ucc__results">
              <ui-progress-circular
                v-if="loading"
                :size="64"
                :indeterminate="true"
              />

              <div v-if="displayResults">
                <p v-if="!results.length" class="no-results">
                  No results found.
                </p>
                <div v-else>
                  <table ref="table" class="table"></table>
                </div>
              </div>
            </div>
          </template>

          <template v-if="step === 2">
            <div class="mb-4">
              <button type="button" class="tiny hollow button" @click="step = 1">Back to search</button>
            </div>
            
            <div class="mb-4 callout" v-if="claim">
              <strong>Claim:</strong><br>
              {{ claim.name }}
            </div>
            
            <div class="mb-4">
              What is your relationship to this claim?
            </div>

            <div class="d-md-flex">
              <a class="button me-4" :href="appendClaimToUrl(ownerFormUrl, claim)">Owner</a>
              <a class="button" :href="appendClaimToUrl(repFormUrl, claim)">Representative — Estate (Owner Deceased)</a>
            </div>
          </template>
        </div>
      </div>
    </div>
  `,

  props: ['url', 'owner-form-url', 'rep-form-url'],

  data() {
    return {
      error: {
        name: null,
        zip: null,
      },
      filter: {
        name: '',
        zip: '',
      },
      displayResults: false,
      results: [],
      loading: false,

      step: 1,
      claim: null,
    }
  },

  computed: {
    dtDataSet() {
      const rows = []
      each(this.results, (row) => {
        rows.push({
          num: row.num,
          name: row.name,
          addr: this.getFullAddress(row),
          id: row.id,
        })
      })
      return rows
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.validate()
      },
    },
  },

  methods: {
    appendClaimToUrl(url, claim) {
      return `${url}?claim=${claim.id}`
    },

    validate() {
      each(this.error, (error, key) => {
        this.error[key] = ''
      })

      if (this.filter.name !== '' && this.filter.name.length < 2) {
        this.error.name = 'Enter at least 2 letters'
      }
      if (this.filter.zip !== '' && this.filter.name.zip < 5) {
        this.error.zip = 'Enter 5 digits'
      }

      return keys(pickBy(this.error, error => !!error)).length === 0
    },

    submit() {
      if (!this.validate()) {
        return
      }
      this.resetTable()
      this.displayResults = false
      this.loading = true
      this.results = []

      $.ajax({
        type: 'POST',
        url: this.url,
        data: this.filter,
        dataType: 'json',
      })
        .always(() => {
          this.loading = false
        })
        .done((results) => {
          this.results = results
          this.displayResults = true
          this.$nextTick(() => {
            $(this.$refs.table).DataTable({
              responsive: {
                details: {
                  display: $.fn.dataTable.Responsive.display.childRowImmediate,
                },
              },
              searching: false,
              data: this.dtDataSet,
              order: [[1, 'asc']],
              columns: [
                { data: 'num', title: 'Member #', className: 'all' },
                { data: 'name', title: 'Name', className: 'all' },
                {
                  data: 'addr',
                  title: 'Last Known Address',
                  className: 'min-tablet',
                  render(data) {
                    return `<div class="address">${data}</div>`
                  },
                },
                {
                  data: null,
                  title: '',
                  sortable: false,
                  className: 'all',
                  render(data) {
                    const jsonAttr = escape(JSON.stringify(data))
                    return `<button class="small button js-claim-button" data-claim="${jsonAttr}">Claim</button>`
                  },
                },
              ],
            })
          })
        })
    },

    getFullAddress(row) {
      const lines = []
      if (row.address1) {
        lines.push(row.address1)
      }
      if (row.address2) {
        lines.push(row.address2)
      }
      if (row.address3) {
        lines.push(row.address3)
      }
      if (row.zip) {
        lines.push(row.zip)
      }

      return lines.join('\n')
    },

    resetTable() {
      if (this.datatable) {
        this.datatable.destroy()
      }
    },

    setupTable() {
      $table.DataTable({})
    },
  },

  created() {
    this.datatable = null

    $(document).on('click', '.js-claim-button', (ev) => {
      this.claim = $(ev.currentTarget).data('claim')
      this.step = 2
    })
  },
})

new Vue({
  components: {
    'ui-ucc': UnclaimedCapitalCredits,
  },
  el: '.js-entry-point',
})
